angular.module('iqxCore')
.controller('ElementsCtrl', function ($scope, FormSvc, actionDialogSvc, ApiSvc, $window, newVersionSvc) {
	FormSvc.setOptions($scope,{
		autoEdit:true
  })
  
  console.log($scope)
  //$ocLazyLoad.load('testModule.js').then(function(err){console.log(err)})

	$scope.checkPermissions('OWNER', ["APIDESIGN"])
	$scope.newMoment = undefined//moment().add(1, "months")
	$scope.min = moment().add(-2, "days")
	$scope.max = moment().add(22, "Y")

	$scope.openActionDialog=function(){
		var objToActionDialogue = {
			linkID:'XX14RQVS100220090003',
			type:'Person'
		}
		actionDialogSvc.show($scope, objToActionDialogue)
	}

 $scope.testSubmit=function(){
		console.log($scope.newMoment)
		let spuds = $scope.newMoment
		console.log(spuds.toDate())
		console.log(spuds.format("DD/MM/YYYY HH:mm"))
		console.log(spuds.add(1, "d"))
	}

  $scope.generateMessage=function(type){

    var pReturn = ""

    if(type=="success"){
      pReturn="0:~Dummy Success Message"
    }else if(type=="info"){
      pReturn="150:~Dummy Info Error Message"
    }else if(type=="error"){
      pReturn="44:~Dummy Internal Error Message"
    }

    return $scope.exec("call/NetTestLoop", {pReturn:pReturn})
    .then(function(data){
      alert(".then function executed")
    })
    .catch(function(err){
      console.info("Promise rejected with reason:", err) // log to console that promise was rejected with rejection reason
    })
  }

  $scope.generateAlert = function(){
    FormSvc.alert("Title","Text","success")
  }

  $scope.newVersion = function(){
    newVersionSvc.setAvailable()
  }

})

